module.exports = " <partial :name=name> <slot></slot> </partial> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-datepicker/src/Datepicker.vue
// module id = 918
// module chunks = 2